import type { MiniAppCatalogRow } from '@/api/client';
import { MiniAppShowcaseCard } from './MiniAppShowcaseCard';
import './MiniAppsShowcase.css';

export interface MiniAppsShowcaseProps {
  apps: MiniAppCatalogRow[];
  loading: boolean;
  errorText: string | null;
  onOpenApp: (id: string) => void;
  onToggleLike: (id: string) => void;
  pendingLikeIds: ReadonlySet<string>;
}

export function MiniAppsShowcase({
  apps,
  loading,
  errorText,
  onOpenApp,
  onToggleLike,
  pendingLikeIds,
}: MiniAppsShowcaseProps) {
  if (loading) {
    return (
      <div className="mini-apps-showcase mini-apps-showcase_status">
        <p className="mini-apps-showcase__hint">Загрузка витрины…</p>
      </div>
    );
  }

  if (errorText) {
    return (
      <div className="mini-apps-showcase mini-apps-showcase_status">
        <p className="mini-apps-showcase__error" role="alert">
          {errorText}
        </p>
      </div>
    );
  }

  if (apps.length === 0) {
    return (
      <div className="mini-apps-showcase mini-apps-showcase_status">
        <p className="mini-apps-showcase__hint">
          Нет активных мини-приложений. Запустите синхронизацию: npm run sync:mini-apps
        </p>
      </div>
    );
  }

  return (
    <div className="mini-apps-showcase">
      <ul className="mini-apps-showcase__list">
        {apps.map((app) => (
          <li key={app.id} className="mini-apps-showcase__list-item">
            <MiniAppShowcaseCard
              app={app}
              onOpenApp={onOpenApp}
              onToggleLike={onToggleLike}
              likeBusy={pendingLikeIds.has(app.id)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
